import { createSlice } from "@reduxjs/toolkit";

import { convertToCamelCase } from "../../utils/code-utils";
import { addWebSocketCases } from "../helpers/storeAction";
import {
  addBerth,
  deleteSchedule,
  fetchVoyageSchedule,
  fetchVoyageScheduleCompleteDetails,
  fetchVoyageScheduleDetails,
  updateBerthRotationData,
  updateScheduleLockFact,
  updateSchedulePosition,
} from "../thunks/voyageScheduleThunks";

import type {
  BerthData,
  Schedule,
  ScheduleBunkers,
  ScheduleDeliveries,
  ScheduleOnBoardService,
  ScheduleOperations,
} from "../../utils/types/voyageSchedule";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ScheduleState {
  scheduleList: {
    [key: string]: Schedule[] | null;
  } | null;
  scheduleDetails: ScheduleDetails;
  scheduleCompleteDetails: BerthData | null;
  showCompleted: boolean;
  completedCount: number;
  showCompletedProspects: boolean;
  loading: boolean;
  isProcessing: boolean;
  detailsLoading: boolean;
  error: string | null;
  selectedBerth: Schedule | null; // New property for selected berth
}

interface ScheduleDetails {
  [key: string]: {
    operations: ScheduleOperations[] | null;
    deliveries: ScheduleDeliveries[] | null;
    on_board_services: ScheduleOnBoardService[] | null;
    bunkers: ScheduleBunkers[] | null;
  };
}

const initialState: ScheduleState = {
  scheduleList: null,
  scheduleDetails: {},
  scheduleCompleteDetails: null,
  showCompleted: true,
  completedCount: 0,
  showCompletedProspects: false,
  loading: false,
  isProcessing: false,
  detailsLoading: false,
  error: null,
  selectedBerth: null, // Initialize as null
};

const voyageSchedule = createSlice({
  name: "voyageSchedule",
  initialState,
  reducers: {
    // reset: (state) => {
    //   state.scheduleList = null;
    //   state.showCompletedProspects = false;
    //   state.loading = false;
    //   state.error = null;
    // },
    // countCompleted: (state) => {
    //   state.completedCount = state.scheduleList.filter(
    //     (schedule) => schedule.status === "Completed"
    //   ).length;
    // },
    toggleCompletedList: (state) => {
      state.showCompleted = !state.showCompleted;
    },
    toggleCompletedProspects: (state) => {
      state.showCompletedProspects = !state.showCompletedProspects;
    },
    selectBerth(state, action: PayloadAction<Schedule>) {
      state.selectedBerth = action.payload; // Set the selected berth
    },
    clearSelectedBerth(state) {
      state.selectedBerth = null; // Clear the selected berth
    },

    clearScheduleDetails(state) {
      state.scheduleDetails = {};
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(fetchVoyageSchedule.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(
    //     fetchVoyageSchedule.fulfilled,
    //     (state, action: PayloadAction<Schedule[]>) => {
    //       state.loading = false;
    //       if (!state.scheduleList) {
    //         state.scheduleList = {};
    //       }
    //       state.scheduleList[action.payload?.[0].jobId] = action.payload || [];
    //     }
    //   )
    //   .addCase(fetchVoyageSchedule.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = "An error occurred. Please try again.";
    //   });

    // builder
    //   .addCase(updateBerthRotationData.pending, (state) => {
    //     state.isProcessing = true;
    //     state.error = null;
    //   })
    //   .addCase(updateBerthRotationData.fulfilled, (state, action) => {
    //     state.isProcessing = false;
    //   })
    //   .addCase(updateBerthRotationData.rejected, (state, action) => {
    //     state.error = "An error occurred. Please try again.";
    //     state.isProcessing = false;
    //   });

    // builder
    //   .addCase(updateScheduleLockFact.pending, (state) => {
    //     state.isProcessing = true;
    //     state.error = null;
    //   })
    //   .addCase(updateScheduleLockFact.fulfilled, (state, action) => {
    //     if (!state.scheduleList) {
    //       state.scheduleList = {};
    //     }
    //     state.scheduleList[action.payload?.[0].jobId] = action.payload || [];
    //     state.isProcessing = false;
    //   })
    //   .addCase(updateScheduleLockFact.rejected, (state, action) => {
    //     state.error = "An error occurred. Please try again.";
    //     state.isProcessing = false;
    //   });

    // builder
    //   .addCase(updateSchedulePosition.pending, (state) => {
    //     state.isProcessing = true;
    //     state.error = null;
    //   })
    //   .addCase(updateSchedulePosition.fulfilled, (state, action) => {
    //     if (!state.scheduleList) {
    //       state.scheduleList = {};
    //     }
    //     state.scheduleList[action.payload?.[0].jobId] = action.payload || [];
    //     state.isProcessing = false;
    //   })
    //   .addCase(updateSchedulePosition.rejected, (state, action) => {
    //     state.error = "An error occurred. Please try again.";
    //     state.isProcessing = false;
    //   });

    // builder
    //   .addCase(deleteSchedule.pending, (state) => {
    //     state.isProcessing = true;
    //     state.error = null;
    //   })
    //   .addCase(deleteSchedule.fulfilled, (state, action) => {
    //     if (state.scheduleList && state.scheduleList[action.payload.jobId])
    //       state.scheduleList[action.payload.jobId] =
    //         state.scheduleList[action.payload.jobId]?.filter(
    //           (schedule) => action.payload?.berthId !== schedule.id
    //         ) || [];
    //     state.isProcessing = false;
    //   })
    //   .addCase(deleteSchedule.rejected, (state, action) => {
    //     state.error = "An error occurred. Please try again.";
    //     state.isProcessing = false;
    //   });

    // builder
    //   .addCase(addBerth.pending, (state) => {
    //     state.isProcessing = true;
    //     state.error = null;
    //   })
    //   .addCase(addBerth.fulfilled, (state, action) => {
    //     console.log(action.payload);
    //     if (!state.scheduleList) {
    //       state.scheduleList = {};
    //     }
    //     state.scheduleList[action.payload?.[0].jobId] = [
    //       ...(state.scheduleList[action.payload?.[0].jobId] || []),
    //       ...action.payload,
    //     ];
    //     state.isProcessing = false;
    //   })
    //   .addCase(addBerth.rejected, (state, action) => {
    //     state.error = "An error occurred. Please try again.";
    //     state.isProcessing = false;
    //   });

    builder
      .addCase(fetchVoyageSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchVoyageSchedule.fulfilled,
        (
          state,
          action: PayloadAction<{
            jobId: string;
            data: Schedule[];
          }>
        ) => {
          state.loading = false;
          state.error = null;

          const { payload } = action;

          const { jobId } = payload;
          if (!jobId) {
            state.error = "Invalid job ID in response";
            return;
          }

          if (!state.scheduleList) {
            state.scheduleList = {};
          }
          state.scheduleList[jobId] = payload.data || [];
        }
      )
      .addCase(fetchVoyageSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error?.message || "Failed to fetch voyage schedule";
      });

    builder
      .addCase(updateBerthRotationData.pending, (state) => {
        state.isProcessing = true;
        state.error = null;
      })
      .addCase(updateBerthRotationData.fulfilled, (state, action) => {
        state.isProcessing = false;
        state.error = null;
        // API response is the source of truth - don't merge with current state
        // Fresh data will be fetched via fetchVoyageScheduleCompleteDetails in the component
      })
      .addCase(updateBerthRotationData.rejected, (state, action) => {
        state.error =
          action.error?.message || "Failed to update berth rotation data";
        state.isProcessing = false;
      });

    builder
      .addCase(updateScheduleLockFact.pending, (state) => {
        state.isProcessing = true;
        state.error = null;
      })
      .addCase(updateScheduleLockFact.fulfilled, (state, action) => {
        state.isProcessing = false;
        state.error = null;

        const { payload } = action;
        if (!payload || !Array.isArray(payload) || payload.length === 0) {
          return;
        }

        const jobId = payload[0]?.jobId;
        if (!jobId) {
          state.error = "Invalid job ID in response";
          return;
        }

        if (!state.scheduleList) {
          state.scheduleList = {};
        }
        state.scheduleList[jobId] = payload;
      })
      .addCase(updateScheduleLockFact.rejected, (state, action) => {
        state.error =
          action.error?.message || "Failed to update schedule lock fact";
        state.isProcessing = false;
      });

    builder
      .addCase(updateSchedulePosition.pending, (state) => {
        state.isProcessing = true;
        state.error = null;
      })
      .addCase(updateSchedulePosition.fulfilled, (state, action) => {
        state.isProcessing = false;
        state.error = null;

        const { payload } = action;
        if (!payload || !Array.isArray(payload) || payload.length === 0) {
          return;
        }

        const jobId = payload[0]?.jobId;
        if (!jobId) {
          state.error = "Invalid job ID in response";
          return;
        }

        if (!state.scheduleList) {
          state.scheduleList = {};
        }
        state.scheduleList[jobId] = payload;
      })
      .addCase(updateSchedulePosition.rejected, (state, action) => {
        state.error =
          action.error?.message || "Failed to update schedule position";
        state.isProcessing = false;
      });

    builder
      .addCase(deleteSchedule.pending, (state) => {
        state.isProcessing = true;
        state.error = null;
      })
      .addCase(deleteSchedule.fulfilled, (state, action) => {
        state.isProcessing = false;
        state.error = null;

        const { payload } = action;
        if (!payload || !payload.jobId || !payload.berthId) {
          state.error = "Invalid payload for schedule deletion";
          return;
        }

        if (!state.scheduleList || !state.scheduleList[payload.jobId]) {
          return;
        }

        if (state.scheduleList[payload.jobId]) {
          state.scheduleList[payload.jobId] = state.scheduleList[
            payload.jobId
          ]!.filter((schedule) => schedule.id !== payload.berthId);
        }
      })
      .addCase(deleteSchedule.rejected, (state, action) => {
        state.error = action.error?.message || "Failed to delete schedule";
        state.isProcessing = false;
      });

    builder
      .addCase(addBerth.pending, (state) => {
        state.isProcessing = true;
        state.error = null;
      })
      .addCase(addBerth.fulfilled, (state, action) => {
        state.isProcessing = false;
        state.error = null;

        const { payload } = action;
        if (!payload || !Array.isArray(payload) || payload.length === 0) {
          return;
        }

        const jobId = payload[0]?.jobId;
        if (!jobId) {
          state.error = "Invalid job ID in response";
          return;
        }

        if (!state.scheduleList) {
          state.scheduleList = {};
        }

        const existingSchedules = state.scheduleList[jobId] || [];
        state.scheduleList[jobId] = [...existingSchedules, ...payload];
      })
      .addCase(addBerth.rejected, (state, action) => {
        state.error = action.error?.message || "Failed to add berth";
        state.isProcessing = false;
      });

    builder
      .addCase(fetchVoyageScheduleDetails.pending, (state) => {
        state.detailsLoading = true;
        state.error = null;
      })
      .addCase(fetchVoyageScheduleDetails.fulfilled, (state, action) => {
        const { berth_id, ...data } = action.payload;
        state.detailsLoading = false;
        state.scheduleDetails[berth_id] = data;
      })
      .addCase(fetchVoyageScheduleDetails.rejected, (state) => {
        state.detailsLoading = false;
        state.error = "An error occurred. Please try again.";
      });

    builder
      .addCase(fetchVoyageScheduleCompleteDetails.pending, (state) => {
        state.detailsLoading = true;
        state.error = null;
      })
      .addCase(
        fetchVoyageScheduleCompleteDetails.fulfilled,
        (state, action) => {
          state.detailsLoading = false;
          state.scheduleCompleteDetails = action.payload;
        }
      )
      .addCase(fetchVoyageScheduleCompleteDetails.rejected, (state) => {
        state.detailsLoading = false;
        state.error = "An error occurred. Please try again.";
      });

    addWebSocketCases(builder, "voyageSchedule", "scheduleList");
  },
});

export const {
  // reset,
  toggleCompletedList,
  toggleCompletedProspects,
  selectBerth,
  clearSelectedBerth,
  // countCompleted,
  clearScheduleDetails,
} = voyageSchedule.actions;
export default voyageSchedule.reducer;
